import * as Sentry from '@sentry/tanstackstart-react';
import { createRouter as createTanStackRouter } from '@tanstack/react-router';

import { getRelayEnvironment } from '@/relay/environment';
import { routeTree } from '@/routeTree.gen';

const sentryEnabledModes = ['production', 'staging'];

export function getRouter() {
  const { environment: relayEnvironment } = getRelayEnvironment();
  const router = createTanStackRouter({
    routeTree,
    scrollRestoration: true,
    context: {
      relayEnvironment,
    },
  });

  if (!router.isServer) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      enabled: sentryEnabledModes.includes(import.meta.env.MODE),
      tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
      initialScope: {
        tags: { service: 'landlord' },
        attributes: { service: 'landlord' },
      },
      integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
      tracePropagationTargets: [
        'http://localhost:4000',
        'https://api.getbudgy.co.uk',
        'https://api.staging.getbudgy.co.uk',
      ],
    });
  }

  return router;
}

declare module '@tanstack/react-start' {
  interface Register {
    ssr: true;
    router: Awaited<ReturnType<typeof getRouter>>;
  }
}
